
import documents from '../api/documents'

export const state = {
  documents: [],
  document_pagination_data: {},
  document: ''
}

export const getters = {
  documents: state => state.documents,
  document_pagination_data: state => state.document_pagination_data,
  document: state => state.document
}

export const mutations = {
  ADD_DOCUMENT (state, data) {
    state.documents.push(data)
  },
  SET_DOCUMENTS (state, data) {
    state.documents = data
  },
  SET_DOCUMENT_PAGINATION (state, data) {
    state.document_pagination_data = data
  },
  SHOW_DOCUMENT (state, data) {
    state.document = data
  }
}

export const actions = {
  GET_DOCUMENTS ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      documents.get(data).then(response => {
        commit('SET_DOCUMENTS', response.data.data)
        let paginationData = {
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
          last_page: response.data.last_page
        }
        commit('SET_DOCUMENT_PAGINATION', paginationData)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  CREATE_DOCUMENT ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      documents.create(data).then(response => {
        commit('ADD_DOCUMENT', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  SHOW_DOCUMENT ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      documents.show(id).then(response => {
        commit('SHOW_DOCUMENT', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  EDIT_DOCUMENT ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      documents.update(data, state.document.id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  REMOVE_DOCUMENT ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      documents.delete(id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/documents.js